export const PLAIN_TEXT_FILE = 'PLAIN_TEXT_FILE';
export const UNKNOWN_FILE = 'UNKNOWN_FILE';
export const EXCEL_FILE = 'EXCEL_FILE';

export const getFileTypeCategory = fileExtension => {
  switch (fileExtension.toUpperCase()) {
    case 'CSV':
    case 'TXT':
      return PLAIN_TEXT_FILE;
    case 'XLS':
    case 'XLSX':
      return EXCEL_FILE;
    default:
      return UNKNOWN_FILE;
  }
};

export const convertFileToDownload = (response, fileName) => {
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download',fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};



// WEBPACK FOOTER //
// ./src/shared/helpers/fileTransferHelper.js